<ion-item class="input" lines="none">
  <ion-checkbox
    color="primary"
    slot="{{ slot }}"
    checked="{{ checked }}"
    [value]="value"
    [disabled]="disabled"
    (ionChange)="updateChanges($event.detail.checked)"
  >
  </ion-checkbox>
  <ion-label *ngIf="label">{{ label | translate }}</ion-label>
</ion-item>